
import { useContext } from 'react';
import { NetworkContext } from '../contexts/networkContext';



export const NetworkHook = () => {
    const context = useContext(NetworkContext);
    return context
}